import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { EventGroupClient, Feature } from 'src/WebApiController';

export const GET_EVENT_GROUPS_QUERY_KEY = 'EventGroupClient.getEventGroups';

/**
 * Lists the account's event (season) groups for selection UIs — e.g. creating a
 * purchase order from a season group. Gated behind Feature.PlaceholderEventGroup.
 */
export function useGetEventGroups() {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();
  const hasPlaceholderEventGroupFeature = useUserHasFeature(
    Feature.PlaceholderEventGroup
  );

  const shouldQuery =
    hasPlaceholderEventGroupFeature &&
    !!activeAccountWebClientConfig?.activeAccountId;

  return useQuery({
    queryKey: [
      GET_EVENT_GROUPS_QUERY_KEY,
      activeAccountWebClientConfig?.activeAccountId,
    ],
    async queryFn() {
      if (!shouldQuery) return [];

      try {
        return (
          (await new EventGroupClient(
            activeAccountWebClientConfig
          ).getEventGroups()) ?? []
        );
      } catch (err: unknown) {
        trackError('EventGroupClient.getEventGroups', err as ErrorTypes, {});
        throw err;
      }
    },
    enabled: shouldQuery,
    refetchOnWindowFocus: false,
  });
}
